module.exports = ".sidebar-nav > ul > li.active > a{\r\n\tcolor: #ffffff !important;\r\n}"